export { default } from "./productCategory.api";
export * from "./productCategory.api.types";
